import Cookies from 'js-cookie';

export default class MailchimpForm {

	constructor(element) {
		this.handleSubmit = this.handleSubmit.bind(this);
		this.element = element;
		this.form = this.element ? this.element.querySelector('form') : null;
		this.redirectURLCookie = 'gigs_mailchimp_form_redirect';
	}

	init() {
		if (this.form) {
			this.form.addEventListener('submit', this.handleSubmit);
		}
	}

	destroy() {
		if (this.form) {
			this.form.removeEventListener('submit', this.handleSubmit);
		}
	}

	handleSubmit(e) {
		const { redirect } = e.currentTarget.dataset;
		Cookies.set(this.redirectURLCookie, redirect);
	}
}
